import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';

@Api('api/app/license-settings/')
export class LicenseSettingsDto extends DtoHasApi {
  clientId: string;
  licenseURL: string;
  clientSecret: string;
}
